import axios from 'axios';
import { authHeaders } from './authHeaders';
import {
  Escenario,
  EscenarioResumen,
  CreateEscenarioPayload,
  UpdateEscenarioPayload,
  EscenarioMutationResponse,
} from '../types/Calculadora';

const API_URL = '/api/calculadora';

/** Mensaje de error del backend si vino, o uno genérico. */
function errorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error) && error.response?.data?.error) {
    return String(error.response.data.error);
  }
  return error instanceof Error ? error.message : fallback;
}

const calculadoraService = {
  async listarEscenarios(): Promise<EscenarioResumen[]> {
    const response = await axios.get(`${API_URL}/escenarios`, { headers: authHeaders() });
    return Array.isArray(response.data?.scenarios) ? response.data.scenarios : [];
  },

  async obtenerEscenario(id: number): Promise<Escenario | null> {
    try {
      const response = await axios.get(`${API_URL}/escenarios/${id}`, { headers: authHeaders() });
      return response.data?.scenario ?? null;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) return null;
      throw error;
    }
  },

  async crearEscenario(payload: CreateEscenarioPayload): Promise<EscenarioMutationResponse> {
    try {
      const response = await axios.post(`${API_URL}/escenarios`, payload, { headers: authHeaders() });
      return response.data;
    } catch (error) {
      return { success: false, error: errorMessage(error, 'Error al guardar el escenario') };
    }
  },

  async actualizarEscenario(
    id: number,
    payload: UpdateEscenarioPayload,
  ): Promise<EscenarioMutationResponse> {
    try {
      const response = await axios.patch(`${API_URL}/escenarios/${id}`, payload, {
        headers: authHeaders(),
      });
      return response.data;
    } catch (error) {
      return { success: false, error: errorMessage(error, 'Error al actualizar el escenario') };
    }
  },

  async borrarEscenario(id: number): Promise<EscenarioMutationResponse> {
    try {
      const response = await axios.delete(`${API_URL}/escenarios/${id}`, { headers: authHeaders() });
      return response.data;
    } catch (error) {
      return { success: false, error: errorMessage(error, 'Error al borrar el escenario') };
    }
  },
};

export default calculadoraService;
